import React from 'react';
import { createSelectable } from '../../utils/drag-selector';

const SelectableComponent = ({ children }) => {
  if (children != null || children != undefined) return children;
  else return <div></div>;
};

export default createSelectable(SelectableComponent);
